import { render, staticRenderFns } from "./info-block-row.vue?vue&type=template&id=dbffcd8a&"
import script from "./info-block-row.vue?vue&type=script&lang=ts&"
export * from "./info-block-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports